<template>
  <div>
    <v-dialog width="500" max-width="100vw" v-model="changeCompanyDialog">
      <og-company-selector></og-company-selector>
    </v-dialog>

    <mobile-navigation v-if="$vuetify.breakpoint.name === 'xs'">
      <template slot="topDrawerMenu">
        <slot v-if="$slots.topDrawerMenu" name="topDrawerMenu"></slot>
      </template>
      <template slot="endDrawerMenu">
        <slot v-if="$slots.endDrawerMenu" name="endDrawerMenu"></slot>
      </template>
      <template slot="subSectionMenu">
        <slot v-if="$slots.subSectionMenu" name="subSectionMenu"></slot>
      </template>
    </mobile-navigation>
    <template v-else>
      <v-toolbar
        id="og-main-toolbar"
        class="og-main-toolbar"
        color="primary"
        light
        app
        :clipped-left="clipped"
        :fixed="fixed"
        :height="toolbarHeight"
      >
        <v-toolbar-side-icon class="ml-2" @click.stop="drawer = !drawer">
          <v-icon>mdi-menu</v-icon>
        </v-toolbar-side-icon>

        <!-- <v-btn icon @click.stop="clipped = !clipped">
            <v-icon>web</v-icon>
        </v-btn>-->
        <v-toolbar-items>
          <v-divider vertical></v-divider>
          <template v-for="(item, i) in toolbarItems">
            <v-btn
              :key="i"
              :ref="item.id"
              :id="item.id"
              v-if="
                !item.meta.rightToolbar &&
                  (!item.meta.admin || (item.meta.admin && $store.state.admin)) &&
                  !item.meta.accountMenu
              "
              :input-value="item.path.startsWith('/' + section)"
              flat
              :to="item.path"
            >
              <v-icon class="pr-2">{{ item.icon }}</v-icon>
              <v-badge color="secondary" v-if="item.meta.badge && $data[item.meta.badgeContent]">
                <span slot="badge">
                  <template v-if="$data[item.meta.badgeChecker]">
                    {{ $data[item.meta.badgeContent] }}
                  </template>
                </span>
                {{ $t(item.name) }}
              </v-badge>
              <template v-else>
                {{ $t(item.name) }}
              </template>
            </v-btn>
          </template>
        </v-toolbar-items>

        <v-spacer></v-spacer>
        <v-toolbar-items>
          <template v-for="(item, i) in toolbarItems">
            <v-btn
              :key="i"
              v-bind:class="{
                'white--text': item.path.startsWith('/' + section),
              }"
              v-if="
                item.meta.rightToolbar &&
                  (!item.meta.admin || (item.meta.admin && $store.state.admin))
              "
              :input-value="item.path.startsWith('/' + section)"
              flat
              :to="item.path"
            >
              <v-badge color="secondary" v-if="item.meta.badge && $data[item.meta.badgeContent]">
                <span slot="badge">
                  <template v-if="$data[item.meta.badgeChecker]">
                    {{ $data[item.meta.badgeContent] }}
                  </template>
                </span>
                <v-icon>{{ item.icon }}</v-icon>
              </v-badge>
              <template v-else>
                <v-icon class="pr-2">{{ item.icon }}</v-icon>
                {{ $t(item.name) }}
              </template>
            </v-btn>
          </template>

          <v-menu
            offset-y
            attach="#og-main-toolbar"
            left
            nudge-left="10px"
            origin="center center"
            transition="scale-transition"
          >
            <v-btn
              id="my-account-menu"
              slot="activator"
              color="primary"
              class="black--text"
              depressed
            >
              <span class="text-capitalize">
                {{ accountName | truncate(20, '...') }}
              </span>
              <v-icon class="black--text ml-3" dark>mdi-account-circle-outline</v-icon>
            </v-btn>
            <v-card>
              <v-list>
                <v-list-tile v-if="isMultiCompany" @click="changeCompanyDialog = true">
                  <v-list-tile-title>{{ $t('Mis negocios') }}</v-list-tile-title>
                </v-list-tile>

                <v-list-tile v-if="userCanAccessPath('/user/myaccount')" to="/user/myaccount">
                  <v-list-tile-title>{{ $t('Mis datos de usuario') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="userCanAccessPath('/user/myprofile')" to="/user/myprofile">
                  <v-list-tile-title>{{ $t('Perfil de negocio') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="logout()">
                  <v-list-tile-title>{{ $t('Cerrar sesión') }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>
      <v-navigation-drawer
        floating
        class="og-main-sidebar"
        width="200"
        mini-variant-width="65"
        persistent
        :mini-variant="miniVariant"
        :clipped="clipped"
        v-model="drawer"
        enable-resize-watcher
        app
      >
        <v-layout py-0 column fill-height>
          <v-list class="pa-0">
            <v-list-tile :style="{ height: toolbarHeight + 'px' }">
              <v-img
                v-if="miniVariant"
                contain
                :height="toolbarHeight - 10"
                src="/img/ISOTIPO_OPENGES-01.png"
              ></v-img>
              <v-img
                v-else
                contain
                :height="toolbarHeight - 10"
                src="/img/LOGOTIPO_VERSION_1_OPENGES.svg"
              ></v-img>
            </v-list-tile>
            <v-list-tile value="true" @click.stop="miniVariant = !miniVariant">
              <v-list-tile-action class="pr-0">
                <v-icon
                  large
                  color="grey"
                  v-html="miniVariant ? 'mdi-chevron-right' : 'mdi-chevron-left'"
                ></v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title
                  class="caption font-weight-medium grey--text"
                  v-text="$t('Minimizar')"
                ></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-list>
            <slot v-if="$slots.topDrawerMenu" name="topDrawerMenu"></slot>
            <v-tooltip right v-for="(item, i) in drawerItems" :key="i">
              <template v-slot:activator="{ on, attrs }">
                <v-list-tile :to="item.path" v-bind="attrs" v-on="on">
                  <v-list-tile-action class="pr-0">
                    <v-badge
                      color="secondary"
                      v-if="miniVariant && item.meta.badge && $data[item.meta.badgeContent]"
                    >
                      <span slot="badge">
                        <template v-if="$data[item.meta.badgeChecker]">
                          {{ $data[item.meta.badgeContent] }}
                        </template>
                      </span>
                      <v-icon v-html="item.icon"></v-icon>
                    </v-badge>
                    <v-icon v-else v-html="item.icon"></v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-badge
                      color="secondary"
                      v-if="item.meta.badge && $data[item.meta.badgeContent]"
                    >
                      <span slot="badge">
                        <template v-if="$data[item.meta.badgeChecker]">
                          {{ $data[item.meta.badgeContent] }}
                        </template>
                      </span>
                      <v-list-tile-title
                        class="caption font-weight-medium"
                        v-text="item.name"
                      ></v-list-tile-title>
                    </v-badge>
                    <v-list-tile-title
                      v-else
                      class="caption font-weight-medium"
                      v-text="item.name"
                    ></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <span>{{ item.meta.tooltip ? item.meta.tooltip : item.name }}</span>
            </v-tooltip>
            <slot v-if="$slots.subSectionMenu" name="subSectionMenu"></slot>
            <slot v-if="$slots.endDrawerMenu" name="endDrawerMenu"></slot>
          </v-list>
          <v-spacer></v-spacer>

          <v-fade-transition>
            <v-list v-show="helpMenu" :class="{ 'pb-0': miniVariant, 'mb-0': miniVariant }">
              <v-list-tile @click="activateTour()">
                <v-list-tile-action class="pr-0">
                  <v-icon>mdi-television-guide</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title class="caption font-weight-medium">
                    {{ $t('Visita guiada') }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="downloadManual()">
                <v-list-tile-action class="pr-0">
                  <v-icon>mdi-book-open-page-variant</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title class="caption font-weight-medium">
                    {{ $t('Manual de navegación') }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile
                v-if="userHasAnyRole(['pyme', 'autonomous', 'consultant', 'admin', 'superadmin'])"
                @click="downloadFaqs()"
              >
                <v-list-tile-action class="pr-0">
                  <v-icon>mdi-help-box</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title class="caption font-weight-medium">
                    {{ $t('Preguntas frecuentes') }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-fade-transition>

          <v-list :class="{ 'pb-5': miniVariant, 'pb-0': !miniVariant }" class="pb- pt-3">
            <v-list-tile
              @click="helpMenu = !helpMenu"
              :style="{ height: miniVariant ? '36px' : '100px' }"
              class="text-xs-center py-0"
            >
              <v-icon
                id="help-center-image"
                class="align-self-center"
                :size="miniVariant ? '36px' : '100px'"
                color="secondary"
              >
                mdi-lightbulb-on-outline
              </v-icon>
            </v-list-tile>

            <v-list-tile @click="helpMenu = !helpMenu" v-if="!miniVariant" class="pt-0">
              <v-list-tile-content>
                <v-list-tile-title class="text-xs-center">CENTRO DE AYUDA</v-list-tile-title>
                <v-list-tile-text></v-list-tile-text>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <div v-if="!miniVariant" class="px-2 pb-5 text-xs-center help-message">
            <div>¿Necesitas ayuda?</div>
            <div>Llámanos al 95 526 00 49,</div>
            <div>estamos de Lunes a Jueves</div>
            <div>de 9:00 a 18:00</div>
            <div>y Viernes de 9:00 a 14:00</div>
            <div>Estamos encantados de ayudarte.</div>
          </div>
        </v-layout>
      </v-navigation-drawer>
    </template>
  </div>
</template>

<script>
import MobileNavigation from './mobileNavigation';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import OgCompanySelector from '@/components/commons/OgCompanySelector.vue';
import AruRouteGuardMixin from '@/mixins/route-guards/AruRouteGuardMixin.js';

export default {
  mixins: [AruRouteGuardMixin],

  components: {
    MobileNavigation,
    OgCompanySelector,
  },
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      toolbarHeight: 50,
      miniVariant: true,
      helpMenu: false,
      changeCompanyDialog: false,
      unreadedUserMessages: 0,
      userMessagesReady: false,
      userNewLaboralDocuments: false,
      unreadedUserDocuments: 0,
      newLaboralDocuments: 0,
      userDocumentsReady: false,
      userBroadcastMessagesReady: false,

      unreadedUserContableDocuments: 0,
      unreadedUserFiscalDocuments: 0,
      unreadedUserLaboralDocuments: 0,
      unreadedUserBroadcastMessages: 0,
    };
  },
  mounted() {
    this.$root.$on('getNewLaboralRequestDocuments', () => {
      this.getNewLaboralRequestDocuments();
    });
    this.getUnreadedUserMessages();
    this.getUnreadedUserBroadcastMessages();
    this.getUnreadedUserDocuments();
    this.getNewLaboralRequestDocuments();
  },
  destroyed() {
    this.$root.$off('getNewLaboralRequestDocuments');
  },
  computed: {
    logoV2() {
      return require('@/assets/LOGOTIPO_VERSION_1_OPENGES.svg');
    },
    logoMiniV2() {
      return require('@/assets/ISOTIPO_OPENGES-01.png');
    },
    isMultiCompany() {
      return this.$store.getters['companies'].length > 1;
    },
    user() {
      return this.$store.state.user;
    },
    accountName() {
      let companyName = null;
      if (
        this.$store.state.hasOwnProperty('clavedat') &&
        this.$store.state.hasOwnProperty('user') &&
        this.$store.state.user.hasOwnProperty('customer_profile') &&
        this.$store.state.user.customer_profile &&
        this.$store.state.user.customer_profile.hasOwnProperty('fiscal_data') &&
        Array.isArray(this.$store.state.user.customer_profile.fiscal_data)
      ) {
        this.$store.state.user.customer_profile.fiscal_data.forEach(company => {
          if (company.CLAVEDAT == this.$store.state.clavedat) {
            companyName = company.APELNOM;
          }
        });
      }
      return companyName ? companyName : this.user.name;
    },

    currentRoute() {
      return this.$router.currentRoute.fullPath;
    },
    toolbarItems() {
      let items = [];
      this.$router.options.routes.forEach(element => {
        if (
          element.hasOwnProperty('meta') &&
          element.meta.hasOwnProperty('toolbar') &&
          element.meta.toolbar &&
          this.userHasPermissions(element) &&
          this.userHasActiveModule(element)
        ) {
          console.log(this.userHasActiveModule(element));
          console.log(element.name);
          items.push(element);
        }
      });
      return items;
    },

    drawerItems() {
      let result = [];

      this.toolbarItems.forEach(element => {
        if (element.path.startsWith('/' + this.section)) {
          if (element.hasOwnProperty('children')) {
            element.children.forEach(item => {
              if (
                item.hasOwnProperty('meta') &&
                item.meta.hasOwnProperty('drawer') &&
                item.meta.drawer &&
                this.userHasPermissions(item)
              ) {
                result.push(item);
              }
            });
          }
        }
      });

      return result;
    },

    section() {
      let section = '';
      let segments = this.$router.currentRoute.fullPath.split('/');
      if (Array.isArray(segments) && segments[1]) {
        section = segments[1];
      }

      return section;
    },
    currentCompany() {
      return this.$store.getters['currentCompany'];
    },
    codempre() {
      return this.currentCompany ? this.currentCompany.CLAVEDAT : null;
    },
  },
  methods: {
    downloadManual() {
      if (this.userHasAnyRole(['pyme', 'autonomous', 'consultant', 'admin', 'superadmin'])) {
        const config = {
          params: {
            name: 'manual_navegacion_openges',
            extension: 'pdf',
          },
        };
        apiCtrl.downloadBlob('/static/manual', config);
      } else {
        const config = {
          params: {
            name: 'manual_navegacion_opendata',
            extension: 'pdf',
          },
        };
        apiCtrl.downloadBlob('/static/manual-lopd', config);
      }
    },

    downloadFaqs() {
      const config = {
        params: {
          name: 'manual_FAQs',
          extension: 'pdf',
        },
      };
      apiCtrl.downloadBlob('/static/faqs', config);
    },
    logout: function() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },
    activateTour() {
      apiCtrl.post('/user/activate-tour').then(res => {
        this.$store.dispatch('reactivateTour');
      });
    },
    getUnreadedUserBroadcastMessages() {
      this.userBroadcastMessagesReady = false;
      if (this.$store.state.user) {
        apiCtrl.get('/user-broadcast-messages/my-unreaded').then(res => {
          this.unreadedUserBroadcastMessages =
            res.hasOwnProperty('data') &&
            res.data &&
            res.data.hasOwnProperty('data') &&
            res.data.data &&
            res.data.data.length
              ? res.data.data.length
              : 0;
          this.userBroadcastMessagesReady = true;
        });
      }
    },
    getUnreadedUserMessages() {
      this.userMessagesReady = false;
      if (this.$store.state.user) {
        apiCtrl
          .get('/message-notification', {
            params: {
              constraint: {
                readed: '0:=',
                user_id: this.$store.state.user.id + ':=',
              },
            },
          })
          .then(res => {
            this.unreadedUserMessages =
              res.hasOwnProperty('data') &&
              res.data &&
              res.data.hasOwnProperty('data') &&
              res.data.data &&
              res.data.data.length
                ? res.data.data.length
                : 0;
            this.userMessagesReady = true;
          });
      }
    },
    getNewLaboralRequestDocuments() {
      this.userNewLaboralDocuments = false;
      if (this.$store.state.user) {
        apiCtrl
          .get('/laboral-requests/new-documents', {
            params: {
              codempre: this.codempre,
            },
          })
          .then(res => {
            this.newLaboralDocuments =
              (res.hasOwnProperty('data') &&
                res.data &&
                res.data.hasOwnProperty('documents') &&
                res.data.documents) ||
              0;
            this.userNewLaboralDocuments = true;
          });
      }
    },
    getUnreadedUserDocuments() {
      this.userDocumentsReady = false;
      if (this.$store.state.user) {
        apiCtrl
          .get('/document-notification', {
            params: {
              constraint: {
                readed: '0:=',
                user_id: this.$store.state.user.id + ':=',
              },
            },
          })
          .then(res => {
            if (
              res.hasOwnProperty('data') &&
              res.data &&
              res.data.hasOwnProperty('data') &&
              res.data.data
            ) {
              this.unreadedUserDocuments = res.data.data.length ? res.data.data.length : 0;
              this.unreadedUserContableDocuments = res.data.data.filter(
                docNotification => docNotification.document_category === 'Contable',
              ).length;
              this.unreadedUserFiscalDocuments = res.data.data.filter(
                docNotification => docNotification.document_category === 'Fiscal',
              ).length;
              this.unreadedUserLaboralDocuments = res.data.data.filter(
                docNotification => docNotification.document_category === 'Laboral',
              ).length;
            }
            this.userDocumentsReady = true;
          });
      }
    },
    discardHelp() {
      for (const key in this.visitGuide) {
        if (this.visitGuide.hasOwnProperty(key)) {
          this.visitGuide[key] = false;
        }
      }
    },
    nextHelpStep(i) {
      this.visitGuide[i] = false;
      if (this.visitGuide.hasOwnProperty(i + 1)) {
        this.visitGuide[i + 1] = true;
      }
    },
  },
  watch: {
    $route(to, from) {
      this.getUnreadedUserMessages();
      this.getUnreadedUserDocuments();
      this.getNewLaboralRequestDocuments();
    },
  },
};
</script>

<style lang="scss">
#help-center-image {
  margin: auto;
}

.og-main-toolbar {
  .v-toolbar__side-icon {
    margin-left: 0px;
  }
  .v-toolbar__content {
    padding: 0px;
  }
  .v-btn {
    border-radius: 0px;
  }
  .v-badge__badge {
    z-index: 100;
  }
}
.og-main-sidebar {
  .v-list__tile__action {
    min-width: 35px;
  }
}
</style>
